import setFieldValue from "@iewcasia/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    billingLastName: state.customCreateAccountForm.fieldValues.billingLastName,
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const LastNameWidget: React.FC<Props> = ({ billingLastName, previouslyPurchased, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Contact Last Name");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, billingLastName, "billingLastName", () =>
        validateFieldBy(isRequired, label, billingLastName, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "billingLastName", value: event.target.value });
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={billingLastName || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LastNameWidget);
